import { create } from 'zustand';

interface LoadingState {
    isLoading: boolean;
    activeRequests: number;
    setLoading: (loading: boolean) => void;
    incrementRequests: () => void;
    decrementRequests: () => void;
}

export const useLoadingStore = create<LoadingState>((set, get) => ({
    isLoading: false,
    activeRequests: 0,
    setLoading: (loading: boolean) => set({ isLoading: loading }),
    incrementRequests: () => {
        const { activeRequests } = get();
        set({
            activeRequests: activeRequests + 1,
            isLoading: true
        });
    },
    decrementRequests: () => {
        const { activeRequests } = get();
        const newCount = Math.max(0, activeRequests - 1);
        set({
            activeRequests: newCount,
            isLoading: newCount > 0
        });
    },
})); 